var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-screen sm:h-screen flex flex-col overflow-hidden"},[_c('router-view'),_c('IwalyNotifications')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }